import axios from 'axios';

const API_BASE = window.API_URL || process.env.REACT_APP_API_URL || 'https://api.vestgrow.dpdns.org/api';

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('vg_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('vg_token');
      localStorage.removeItem('vg_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const loanAPI = {
  plans:        ()   => api.get('/loans/plans'),
  myLoans:      ()   => api.get('/loans/my'),
  myReferrals:  ()   => api.get('/loans/my-referrals'),
  apply:        (id) => api.post('/loans/apply', { loan_plan_id: id }),
  repay:        (id) => api.post(`/loans/${id}/repay`),
};

export const vestTradesAPI = {
  tiers:             ()        => api.get('/vesttrades/tiers'),
  my:                ()        => api.get('/vesttrades/my'),
  invest:            (data)    => api.post('/vesttrades/invest', data),
  claimInvestment:   (id)      => api.post(`/vesttrades/investments/${id}/claim`),
  withdraw:          (data)    => api.post('/vesttrades/withdraw', data),
  passkeyRegisterStart:  (data) => api.post('/auth/passkey/register/start', data),
passkeyRegisterFinish: (data) => api.post('/auth/passkey/register/finish', data),
passkeyLoginStart:     (data) => api.post('/auth/passkey/login/start', data),
passkeyLoginFinish:    (data) => api.post('/auth/passkey/login/finish', data),
passkeyList:           ()     => api.get('/auth/passkey/list'),
passkeyDelete:         (id)   => api.delete(`/auth/passkey/${id}`),
passkeyStatus:         ()     => api.get('/auth/passkey/status'),
passkeyDismissNudge:   ()     => api.post('/auth/passkey/dismiss-nudge'),
};


export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  googleAuth: (data) => api.post('/auth/google', data),
  setPassword: (data) => api.post('/auth/set-password', data),
  me: () => api.get('/auth/me'),
  changePassword: (data) => api.post('/auth/change-password', data),
  createPin: (data) => api.post('/auth/pin/create', data),
  resetPin: (data) => api.post('/auth/pin/reset', data),
};

export const userAPI = {
  home: () => api.get('/user/home'),
  checkin: () => api.post('/user/checkin'),
  claimBonus: (code) => api.post('/user/claim-bonus', { code }),
  team: () => api.get('/user/team'),
  notifications: () => api.get('/user/notifications'),
};

export const productsAPI = {
  list: () => api.get('/products'),
  detail: (id) => api.get(`/products/${id}`),
  purchase: (id, data) => api.post(`/products/${id}/purchase`, data),
  myProducts: () => api.get('/products/my/list'),
};

export const transactionsAPI = {
  depositMethods:   ()        => api.get('/transactions/deposit/methods'),
  deposit:          (formData) => api.post('/transactions/deposit', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  withdraw:         (data)    => api.post('/transactions/withdraw', data),
  history:          (params)  => api.get('/transactions/history', { params }),
  getAccounts:      ()        => api.get('/transactions/accounts'),
  addAccount:       (data)    => api.post('/transactions/accounts', data),
  // Transfer
  transferLookup:   (identifier) => api.post('/transactions/transfer/lookup', { identifier }),
  transfer:         (data)    => api.post('/transactions/transfer', data),
  // Paystack
  paystackInitiate: (data)    => api.post('/paystack/initiate', data),
  paystackRecheck:  (ref)     => api.post('/paystack/recheck', { reference: ref }),
};

export const depositsAPI = {
  validatePromo: (code, amount) => api.post('/deposits/validate-promo', { code, amount }),
  claim:         (data)         => api.post('/deposits/claim', data),
};

export const settingsAPI = {
  public:          () => api.get('/settings/public'),
  transferPublic:  () => api.get('/settings/transfer-public'),
};

export const newsAPI = {
  list:        ()           => api.get('/news'),
  like:        (id)         => api.post(`/news/${id}/like`),
  unlike:      (id)         => api.delete(`/news/${id}/like`),
  getLikes:    (id)         => api.get(`/news/${id}/likes`),
  getComments: (id)         => api.get(`/news/${id}/comments`),
  addComment:  (id, comment)=> api.post(`/news/${id}/comments`, { comment }),
};

export const affiliateAPI = {
  status:      ()  => api.get('/affiliate/status'),
  enable:      ()  => api.post('/affiliate/enable'),
  leaderboard: ()  => api.get('/affiliate/leaderboard'),
};

export const adminAPI = {
  // Dashboard
  dashboard: () => api.get('/admin/dashboard'),

  // Users
  users: (params) => api.get('/admin/users', { params }),
  getUser: (id) => api.get(`/admin/users/${id}`),
  updateUser: (id, data) => api.patch(`/admin/users/${id}`, data),
  setUserPassword: (id, data) => api.post(`/admin/users/${id}/set-password`, data),

  // Transactions
  transactions: (params) => api.get('/admin/transactions', { params }),
  processTransaction: (id, data) => api.post(`/admin/transactions/${id}/process`, data),

  // Products
  products: () => api.get('/admin/products'),
  createProduct: (data) => api.post('/admin/products', data),
  updateProduct: (id, data) => api.patch(`/admin/products/${id}`, data),
  deactivateProduct: (id) => api.patch(`/admin/products/${id}/deactivate`),
  deleteProduct: (id) => api.delete(`/admin/products/${id}`),

  // Settings
  settings: () => api.get('/admin/settings'),
  saveSettings: (updates) => api.post('/admin/settings', { updates }),

  // Banners
  banners: () => api.get('/admin/banners'),
  createBanner: (data) => api.post('/admin/banners', data),
  deleteBanner: (id) => api.delete(`/admin/banners/${id}`),

  // Notifications
  notify: (data) => api.post('/admin/notify', data),
};

export default api;